export function showHomeLevelUpDomFx(host: HTMLElement, newLevel: number): void {
  const existing = host.querySelector(".home-level-up-fx");
  existing?.remove();

  const layer = document.createElement("div");
  layer.className = "home-level-up-fx";
  layer.setAttribute("aria-hidden", "true");
  layer.innerHTML = `
    <div class="home-level-up-fx__burst"></div>
    <div class="home-level-up-fx__text">
      <span class="home-level-up-fx__title">เลเวลอัพ!</span>
      <span class="home-level-up-fx__level">Lv.${newLevel}</span>
    </div>
  `;
  host.appendChild(layer);
  window.setTimeout(() => layer.remove(), 2000);
}
